import React from "react";

import PaginatedGallery from "@/components/paginated-gallery";
import { Animation, SearchQuery } from "@/gql/generated/graphql";

export const ResultsAnimations = ({
  animations = [],
  total,
  onPageChanged,
  page,
}: {
  animations?: NonNullable<SearchQuery["search"]>["animations"];
  total: number;
  onPageChanged: CallableFunction;
  page: number;
}) => {
  if (!animations.length) {
    return (
      <div>
        <h3>Animations</h3>
        <p>No animation results.</p>
      </div>
    );
  }

  return (
    <div>
      <h3>Animations</h3>
      <PaginatedGallery
        page={page}
        totalAnimations={total}
        animations={animations}
        loading={false}
        showPublic={false}
        onPageChanged={onPageChanged}
      />
    </div>
  );
};
